/**
 * 统一页面加载组件
 *
 * 与原项目一致：使用 global/loading.gif + Loading... 文案
 * 用于刷新、路由切换、数据加载等场景
 *
 * @module components/ui/page-loading
 */
import { cn } from '@/lib/utils';

import { CosImage } from './image';

export interface PageLoadingProps {
  /** 自定义类名 */
  className?: string;
  /** 是否全屏展示，默认 true */
  fullScreen?: boolean;
}

/**
 * 页面加载中组件
 *
 * @param props - 组件属性
 * @returns 加载中 UI
 */
export const PageLoading = ({ className, fullScreen = true }: PageLoadingProps) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center text-muted-foreground text-sm bg-background',
      fullScreen ? 'min-h-screen w-full' : 'min-h-[200px]',
      className,
    )}
  >
    <CosImage
      alt="Loading"
      className="w-[90px] h-[90px]"
      height={90}
      src="global/loading.gif"
      width={90}
    />
    <span className="line-clamp-2 text-center mt-2">Loading...</span>
  </div>
);
